import {
  Store as StoreData,
  GenericUserReviewFragment,
  UserReview as UserReviewBase,
  Product as ProductData,
} from '../../types';

export type BelongsTo = {
  id: number | string;
  name: string;
  type: 'product' | 'store';
};

export type Review = {
  id: string;
  rating?: number | null;
  reviewText?: string | null;
  purchaseDate?: string | null;
} | null;

export type UserReview = UserReviewBase & GenericUserReviewFragment;

export type Store = StoreData;

export type Product = ProductData;

export enum Action {
  WRITE = 'write',
  EDIT = 'edit',
}

export enum Questions {
  Rating = 'store.rating',
  Review = 'store.review',
  Recommend = 'store.recommend',
  DeliveryAccuracy = 'store.delivery_accuracy',
  CustomerService = 'store.customer_service',
  PaidReview = 'store.paid_review',
  Email = 'email',
  DisplayName = 'displayname',
  PurchaseDate = 'purchaseDate',
}

export enum Errors {
  USER_ALREADY_HAS_REVIEW = 'user_review.already_exists',
  USER_CONNECTED_TO_STORE = 'user_review.account_connected_to_store',
  USER_HOURLY_LIMIT_REACHED_SHOP = 'user_review.hourly_limit_reached_shop',
  USER_HOURLY_LIMIT_REACHED_ALL_SHOPS = 'user_review.hourly_limit_reached_all_shops',
  UNDER_INVESTIGATION = 'user_review.under_investigation',
  INVALID_PARAMETER = 'request.invalid-parameter',
  UNKNOWN_ERROR = 'dialog.unknown-error',
}

export type ShopReviewFormData = {
  [key in Questions]: string;
};

export type GraphQLError = {
  code: Errors;
  locations: [{ line: number; column: number }];
  message: string;
  path: [string];
  status: number;
};
